// extracted by mini-css-extract-plugin
export var borderColor = "#e8e8eb";
export var dangerColor = "var(--dangerColor)";
export var dangerColor10 = "var(--dangerColor10)";
export var darkTextColor = "var(--darkTextColor)";
export var iconDefaultColor = "hsla(0,0%,100%,.4)";
export var neutralPrimaryColor = "var(--neutralPrimaryColor)";
export var neutralSecondaryColor = "var(--neutralSecondaryColor)";
export var otpInactiveBorderColor = "var(--otpInactiveBorderColor)";
export var primaryColor = "var(--primaryColor)";
export var primaryColor10 = "var(--primaryColor10)";
export var secondaryColor = "var(--secondaryColor)";
export var secondaryColor40 = "#d2efff";
export var secondaryTextColor = "var(--secondaryTextColor)";
export var surfaceColor = "var(--surfaceColor)";
export var surfaceMutedColor = "var(--surfaceMutedColor)";
export var textColor = "var(--textColor)";
export var textOnPrimary = "var(--textOnPrimary)";
export var textOnSecondary = "var(--textOnSecondary)";
export var warningColor = "var(--warningColor)";
export var whiteColor = "#fff";